import "./proxies.less";
import template from "./proxies.html";
import {
	FuzzySearcher,
	FUZZY_OPTIONS
} from "../../utils/fuzzy-search";
import { PROXY_TYPES } from "../../services/proxyService";

function controller(appState, loadingService, $uibModal, $state, proxyService, $stateParams, $location, $scope) {
	const ctrl = this;

	ctrl.promiseTracker = loadingService.getTracker();

	ctrl.$onInit = onInit;

	ctrl.onCollapse = onCollapse;
	ctrl.tableWidthCss = "col-sm-9";

	ctrl.table = {
		data: [],
		actions: {},
		sort: {
			predicate: "Name",
			direction: "asc"
		},
		filter: () => filterTable(),
		reset: () => reset(),
		filterBy: null
	};
	ctrl.paginatorOptions = {};

	ctrl.searcher = new FuzzySearcher([], FUZZY_OPTIONS.PROXIES);

	function onInit() {
		ctrl.form = appState.forms.selected;

		switch($state.current.name) {
			case "authenticated.analytics":
				ctrl.singularItemLabel = "Query";
				ctrl.pluralItemLabel = "Queries";
				ctrl.proxyTypes = [PROXY_TYPES.query, PROXY_TYPES.system];
				break;

			case "authenticated.operations":
				ctrl.singularItemLabel = "Operation";
				ctrl.pluralItemLabel = "Operations";
				ctrl.proxyTypes = [PROXY_TYPES.operation, PROXY_TYPES.system];
				break;

			case "authenticated.reporting":
				ctrl.singularItemLabel = "Report";
				ctrl.pluralItemLabel = "Reports";
				ctrl.proxyTypes = [PROXY_TYPES.report];

				break;

			default:
				break;
		}

		getProxies();

		// Handle initial deep link
		handleStateChange({ 
			search: $stateParams.search, 
			id: $stateParams.id 
		});

		// Watch for search filter changes to sync URL
		$scope.$watch(() => ctrl.table.filterBy, (newValue, oldValue) => {
			if(newValue !== oldValue) {
				$location.search("search", newValue || null).replace();
				ctrl.table.filter();
			}
		});

		// Watch for state param changes to handle deep linking
		$scope.$on("$locationChangeSuccess", () => {
			const searchParams = $location.search();
			handleStateChange({ 
				search: searchParams.search, 
				id: searchParams.id 
			});
		});
	}

	/**
	 * Centralized handler for state changes - evaluates search and modal state
	 */
	function handleStateChange({ search, id } = {}) {
		// Handle search change - sync filter
		if(search !== ctrl.table.filterBy) {
			ctrl.table.filterBy = search || null;
		}

		// Handle modal state (id)
		handleModalState({ id });
	}

	/**
	 * Handle modal state based on URL params - opens proxy modal
	 */
	function handleModalState({ id } = {}) {
		if(!id) {
			return;
		}

		const proxy = ctrl.table.data.find(p => p.Id == id);
		if(proxy) {
			openModal(proxy);
		}
		else {
			resetModal();
		}
	}

	function resetModal() {
		$location.search("id", null).replace();
	}

	async function openModal(proxyHeader) {
		try {
			await $uibModal.open({
				component: "proxy-modal",
				size: "m",
				backdrop: "static",
				keyboard: false,
				resolve: {
					proxy: () => proxyHeader,
					title: () => ctrl.singularItemLabel
				}
			}).closed;
		}
		finally {
			resetModal();
			$scope.$apply();
		}
	}

	function getProxies() {
		const forThisScreen = proxyService.getProxiesByType(ctrl.proxyTypes);

		setTableData(forThisScreen);
	}

	function setTableData(proxies) {
		ctrl.table.data = proxies;
		ctrl.searcher.setCollection(proxies);
		ctrl.paginatorOptions = {
			...ctrl.paginatorOptions, 
			totalItems: ctrl.table.data.length
		};
	}

	function filterTable() {
		ctrl.table.data = (ctrl.table.filterBy) ?
			ctrl.searcher.search(ctrl.table.filterBy) :
			ctrl.searcher.collection;

		ctrl.paginatorOptions = {
			...ctrl.paginatorOptions, 
			totalItems: ctrl.table.data.length
		};
	}

	function reset() {
		ctrl.table.filterBy = null;
		ctrl.table.filter();
	}

	function onCollapse() {
		ctrl.tableWidthCss = ctrl.isCollapsed ? "col-sm-12" : "col-sm-9";
	}
}

export default angular
	.module("vesl.screens.proxies", [])
	.component("proxies", {
		template,
		controller,
		bindings: { form: "<" }
	}).name;
